// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__jliNU","productName":"Table_productName__-yl6S"};